<template>
  <div>
    <div class="mask" v-if="isShow" @click="close"></div>
    <div class="iphone-x fx-row share" :class="showStyle">
      <!-- 小程序 -->
      <div class="fx-1" @click="shareMiniProm">
        微信
      </div>
      <!-- 朋友圈 -->
      <div class="fx-1" @click="sharePengyouquan">
        朋友圈
      </div>
    </div>
  </div>
</template>

<script>
  // import {
  //   invoke
  // } from "@Utility/native-api-promise";
  import nativeApi from '@/utils/native-api'

  import setNavigationRightShareBtn from '../mixin/setNavigationRightShareBtn.js'

  // import base64 from "@Utility/base64";

  const shareURL = 'https://h5.133.cn/gtgjwap/h5/vipCard/goldSale'
  export default {
    name: "share",
    props: ["isShow"],
    mixins: [
      setNavigationRightShareBtn
    ],
    data() {
      return {

      }
    },
    computed: {
      showStyle() {
        let style = [""];

        if (this.isShow) {
          style = ["show"];
        }

        return style;
      }
    },
    methods: {
      //分享小程序
      shareMiniProm() {
        nativeApi.invoke('sharePage', {
          title: '高铁管家黄金会员超值大礼包，限时特惠',
          desc: '购会员礼包，享会员专属权益',
          link: shareURL,
          imgUrl: 'https://cdn.133.cn/gtgj/web/goldSale/sharepng@2x.png',
          type:'weixin'
        }).then(() => {
          GA.track('goldSale', 'sharePageWeixin', 'APP')
        })
      },
      //分享朋友圈
      sharePengyouquan() {
        nativeApi.invoke('sharePage', {
          title: '高铁管家黄金会员超值大礼包，限时特惠',
          desc: '购会员礼包，享会员专属权益',
          link: shareURL,
          imgUrl: 'https://cdn.133.cn/gtgj/web/goldSale/sharepng@2x.png',
          type:'pengyouquan'
        }).then(() => {
          GA.track('goldSale', 'pengyouquan', 'APP')
        })
      },
      showShare() {
        this.$emit("show");
      },
      close() {
        this.$emit("close");
      },
      init() {
        //APP初始化右上角分享按钮
        this.setNavigationRightShareBtn({
          icon: 1,
          callBack: this.showShare
        })
      }
    },
    created() {
      this.init();
    }
  };
</script>

<style lang="scss" scoped>
  .mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.75);
  }

  .share {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    z-index: 999;
    background: #ffffff;
    opacity: 0.9;
    transform: translateY(100px);
    transition: transform 0.3s ease-out;
    box-sizing: border-box;
    padding: 20px 0;
    text-align: center;

    &.show {
      transform: translateY(0);
    }

    >div {
      box-sizing: border-box;
      padding-top: 40px;
      font-size: 12px;
      position: relative;
    }

    >div:nth-of-type(1) {
      background: url("https://cdn.133.cn/gtgj/icon/smprogram/grabTicket/share/weixin2x.png") center no-repeat;
      background-size: 35px auto;
      background-position: top center;
    }

    >div:nth-of-type(2) {
      background: url("https://cdn.133.cn/gtgj/icon/smprogram/grabTicket/share/moment2x.png") center no-repeat;
      background-size: 35px auto;
      background-position: top center;
    }
  }
</style>


// WEBPACK FOOTER //
// src/projects/vipCard/pages/goldSale/components/share.vue